import PanoControlButtonV2 from './PanoControlButtonV2';
import './PanoControlsV2.scss';

const PanoControlsV2 = ({ autoRotate, setAutoRotate, autoRotateDirection, primaryColor }) => {
  return (
    <div className="pano-controls-v2">
      { setAutoRotate &&
          <PanoControlButtonV2
            icon={autoRotateDirection !== 'clockwise' ? 'rotate_left' : 'rotate_right'}
            title="Auto Rotate"
            active={autoRotate}
            onClick={() => setAutoRotate(!autoRotate)}
            primaryColor={primaryColor}
          />
      }
    </div>
  )
}

export default PanoControlsV2;
